import { t } from "i18next";
import { getMany } from "services/leave_type";
import { Util } from "common/util";
import Enum from "common/enums";
import withDataTable from "../withDataTable";
import FormInsertOrUpdate from "./FormInsertOrUpdate";

const util = new Util();
const pathName = "/setting/leave-type";
const columns = [
  {
    title: t("text_leave_type"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: `${t("text_entilement")}`,
    dataIndex: "numberAllow",
    key: "numberAllow",
    render: (entilement, record) => {
      if (entilement) {
        if (record.type === Enum.LEAVE_TYPE.MATERNITY) return `${entilement} weeks`;
        if (record.type === Enum.LEAVE_TYPE.PATERNITY_LEAVE) return `${entilement} weeks`;
      }
      
      return `${entilement} days`;
    }
  },
  {
    title: t("text_carry_forward"),
    dataIndex: "allowRemainMaximum",
    key: "allowRemainMaximum",
    render: allowRemainMaximum => allowRemainMaximum ? allowRemainMaximum : ""
  },
  {
    title: t("text_order"),
    dataIndex: "order",
    key: "order",
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 10;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_leave_types"),
  columns,
  pathName,
  showActionAdd: false,
  showActionDelete: false,
  defaultCurrent,
  defaultPageSize,
  FormInsertOrUpdate,
  handleSearch,
  getData,
  handleAddNew: (modalRef) => modalRef.showModal(),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id)
});
